import { header_vector, header_vector_hover, left_vector, left_vector_h, privacy_bg, right_vector, right_vector_h } from "assets";
import { useState } from "react";

function Privacy() {
    const [hoverTarget, setHoverTarget] = useState(null);

    // Handle mouse events
    const handleMouseEnter = (target) => {
        setHoverTarget(target);
    };

    const handleMouseLeave = () => {
        setHoverTarget(null);
    };

    return (
        <div className="privacy-container user-select-none exo-2">
            <div
                className="privacy-main-section"
                onMouseEnter={() => handleMouseEnter('background')}
                onMouseLeave={handleMouseLeave}
            >
                {/* Background with circuit pattern */}
                <div className={`privacy-background ${hoverTarget === 'content' ? 'grayscale' : ''}`}>
                    <div className={`privacy-circuit-overlay ${hoverTarget === 'content' ? 'grayscale' : ''}`}></div>
                </div>

                {/* Left vector frame */}
                <div className={`privacy-left-vector ${hoverTarget === 'content' ? 'active' : ''}`}>
                    {/* Default vector */}
                    {hoverTarget !== 'content' && (
                        <img
                            src={left_vector}
                            alt="Left vector frame"
                            className="privacy-vector-img"
                        />
                    )}

                    {/* Active vector (shown on hover) */}
                    {hoverTarget === 'content' && (
                        <img
                            src={left_vector_h}
                            alt="Left vector frame active"
                            className="privacy-vector-img"
                        />
                    )}
                </div>


                {/* Content box */}
                <div
                    className={`privacy-content-box ${hoverTarget === 'content' ? 'active' : ''}`}
                    onMouseEnter={(e) => {
                        e.stopPropagation();
                        handleMouseEnter('content');
                    }}
                    onMouseLeave={handleMouseLeave}
                >
                    {/* Header with different background on hover */}
                    <div className="privacy-header">
                        {/* Conditional header background */}
                        {hoverTarget !== 'content' ? (
                            <img
                                src={header_vector}
                                alt="Header background"
                                className="privacy-header-bg"
                            />
                        ) : (
                            <img
                                src={header_vector_hover}
                                alt="Header active background"
                                className="privacy-header-bg"
                            />
                        )}

                        <span className="privacy-header-text">PRIVACY POLICY</span>
                    </div>

                    {/* Content area */}
                    <div className="privacy-content-area">
                        <p className="privacy-paragraph">
                            This Privacy Policy ("Policy") provides for Dominate the Skies
                            ("Dominate the Skies," "we" "our" or "us") policy regarding collection,
                            sharing, and use of information provided by you ("you" "your"). By
                            continuing the use of our platform services ("Platform") to sell and buy
                            your products, you signify your acceptance of this Policy.
                        </p>

                        <h3 className="privacy-section-subtitle">Information We Collect</h3>
                        <p className="privacy-paragraph">
                            While some parts of the Platform allow you to visit as guest and remain
                            anonymous, restricting your access to certain content and features of
                            the platform, you may need to provide us with certain information for
                            registering as seller on the Platform. For instance, you may need to
                            provide us with information including but not limited to name, birth
                            date, a profile name, payment-related information, phone number,
                            password, email, and zip/postal code and other similar information. Once
                            you give us your personal information, you are not anonymous to us.
                        </p>
                        <p className="privacy-paragraph">
                            Where possible, we indicate which fields are required and which fields
                            are optional. The post messages on our message boards, personalised
                            messages, images, photos, gift card message box, chat rooms or other
                            message areas or leave feedback/product review on the Platform, are
                            collected by us. Please note such messages posted by you in public
                            domain and can be read by others as well, please exercise caution while
                            posting such messages, personal details, photos and reviews.
                        </p>

                        <h3 className="privacy-section-subtitle">Information We Collect Automatically</h3>
                        <p className="privacy-paragraph">
                            We collect some information automatically when you visit, access, or use
                            the Platform. This includes information about the application usage,
                            user interactions, purchases, and other activity on the Platform,
                            typically associated with your account profile or with an identifier we
                            have assigned to your device or profile. Our primary goal in doing this
                            is to provide you a safe, efficient, smooth, and customized experience.
                        </p>
                        <p className="privacy-paragraph">
                            While the specific types of information that we automatically collect may vary, they generally include:
                        </p>
                        <ol className="privacy-list">
                            <li className="privacy-list-item">
                                Usage information and statistics about how you interact with the Platform, including the application you used, saved preferences, crash reports, and navigation data.
                            </li>
                            <li className="privacy-list-item">
                                Technical information about your computer, device, hardware, or software you use to access our Platform, such as IP address, device identifiers, and other transactional information.
                            </li>
                            <li className="privacy-list-item">
                                The general location of your device, which we typically derive from your device's IP address.
                            </li>
                        </ol>

                        <h3 className="privacy-section-subtitle">Third Party Websites</h3>
                        <p className="privacy-paragraph">
                            You understand that the Platform may contain links to other websites
                            that we do not operate. If you click on a third-party link, you will be
                            directed to that third party's site. We encourage you to review the
                            privacy policy of every site you visit. We shall not be responsible for
                            the third-party business partner's privacy practices or the content of
                            their privacy policies, and we request you to read their privacy
                            policies prior to disclosing any information.
                        </p>

                        <h3 className="privacy-section-subtitle">Use</h3>
                        <p className="privacy-paragraph">
                            We use personal information to provide the services you request. We use
                            your personal information to assist sellers and business partners in
                            handling and fulfilling orders; enhancing customer experience; to
                            resolve disputes; troubleshoot problems; help promote a safe service;
                            collect money; measure consumer interest in our products and services,
                            inform you about online and offline offers, products, services, and
                            updates; customize your experience; detect and protect us against error,
                            fraud and other criminal activity; enforce our terms and conditions;
                            conduct marketing research, analysis and surveys; and as otherwise
                            described to you at the time of collection of information.
                        </p>

                        <h3 className="privacy-section-subtitle">Recipients of Your Information</h3>
                        <p className="privacy-paragraph">
                            We may share your information for the business purposes with third party
                            entities including but not limited to:
                        </p>
                        <ul className="privacy-list">
                            <li className="privacy-list-item">
                                Our affiliates, business partners, suppliers, and sub-contractors for the performance of any contract we enter into with them or you.
                            </li>
                            <li className="privacy-list-item">
                                Analytics and search engine providers and other selected third parties that assist us in the improvement and optimization of our Platform.
                            </li>
                            <li className="privacy-list-item">
                                Our regulators, law enforcement, or fraud prevention agencies, as well as our advisors, courts, and any other authorized bodies.
                            </li>
                            <li className="privacy-list-item">
                                In the event of restructuring or sale of all or a significant part of our business.
                            </li>
                            <li className="privacy-list-item">
                                To protect the rights, property, or safety of Dominate the Skies, our customers, or others.
                            </li>
                        </ul>

                        <h3 className="privacy-section-subtitle">Privacy Settings</h3>
                        <p className="privacy-paragraph">
                            Depending on your interaction with the Platform, We seek to provide you
                            with meaningful choices about the personal data we collect. The specific
                            choices available to you often vary depending on how you interact with
                            the Platform:
                        </p>
                        <ul className="privacy-list">
                            <li className="privacy-list-item">
                                If we process your personal data based on your consent, you have the right to withdraw your consent at any time by updating the settings in your user profile or contacting us.
                            </li>
                            <li className="privacy-list-item">
                                You can also change your email marketing preferences at any time by using the opt-out mechanism provided in our marketing emails.
                            </li>
                            <li className="privacy-list-item">
                                If you wish to modify any of your user profile information, restrict the processing of your personal data, or cancel your account, you may update the settings in your user profile.
                            </li>
                        </ul>

                        <h3 className="privacy-section-subtitle">Security of the Personal Information</h3>
                        <p className="privacy-paragraph">
                            While we take precautions against all possible security breach in our
                            Platform, Consequently, we cannot guarantee that the Platform shall be
                            free from unauthorized access, hacking, data loss, or other breaches. We
                            urge you to take steps to keep your personal information safe by
                            memorizing your password or storing it safely (separate from your
                            account information), logging out of your user account, keeping your OTP
                            secret and closing your web browser whenever you finish your session or
                            leave your computer in a public area.
                        </p>

                        <h3 className="privacy-section-subtitle">Children's Privacy</h3>
                        <p className="privacy-paragraph">
                            Use of our Platform is available only to persons who can form a legally
                            binding contract under the applicable law. We do not knowingly solicit
                            or collect personal information from children under the age of 18 years.
                            If you have shared any personal information of children under the age of
                            18 years, you represent that you have the authority to do so and permit
                            us to use the information in accordance with this Privacy Policy.
                        </p>

                        <h3 className="privacy-section-subtitle">Data Retention</h3>
                        <p className="privacy-paragraph">
                            We retain your personal information for a period no longer than is
                            required for the purpose for which it was collected or as required under
                            any applicable law. However, we may retain data related to you if there
                            is a legal obligation to retain the data; if required to comply with any
                            applicable statutory or regulatory retention requirement by law; if we
                            believe it may be necessary to prevent fraud or future abuse; to enable
                            Dominate the Skies to exercise its legal rights and/or defend against
                            legal claims; or for other legitimate purposes.
                        </p>

                        <h3 className="privacy-section-subtitle">Consent</h3>
                        <p className="privacy-paragraph">
                            By visiting our Platform or by providing your information, you consent
                            to the collection, use, storage, transfer, disclosure and otherwise
                            processing of your information (including sensitive personal
                            information) on the Platform in accordance with this Privacy Policy.
                        </p>

                        <h3 className="privacy-section-subtitle">Changes to this Policy</h3>
                        <p className="privacy-paragraph">
                            We may update this Policy from time to time. If the changes materially
                            affect the way we use identifiable information that we have already
                            collected, we shall notify you on our Platform. The continued usage of
                            our Platform after such changes have been made to these terms will mean
                            that you accept these changes. Therefore, you are requested to kindly
                            check the Policy regularly for updates.
                        </p>

                        <h3 className="privacy-section-subtitle">GRIEVANCE OFFICER</h3>
                        <p className="privacy-paragraph">
                            In the event of any complaint or issue with respect to the contents of
                            the Platform, you may contact our Grievance Officer at:
                        </p>
                        <p className="privacy-paragraph">
                            <strong>Name:</strong> Reema Maheshwari<br />
                            <strong>Designation:</strong> Co-Founder<br />
                            <strong>Address:</strong> Pune, Maharashtra<br />
                            <strong>Email:</strong> support.dts@bluesquirrelstudios.com<br />
                            <strong>Phone:</strong> 1800-266-4020<br />
                            <strong>Time:</strong> 10:00 IST to 16:00 IST
                        </p>
                    </div>
                </div>
                {/* Right vector frame */}
                <div className={`privacy-right-vector ${hoverTarget === 'content' ? 'active' : ''}`}>
                    {/* Default vector */}
                    {hoverTarget !== 'content' && (
                        <img
                            src={right_vector}
                            alt="Right vector frame"
                            className="privacy-vector-img"
                        />
                    )}

                    {/* Active vector (shown on hover) */}
                    {hoverTarget === 'content' && (
                        <img
                            src={right_vector_h}
                            alt="Right vector frame active"
                            className="privacy-vector-img"
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default Privacy;